
import React from "react";
import { Box, Typography } from "@mui/material";

export default function AccessibilityStatement() {
  return (
    <Box
      sx={{
        direction: "rtl",
        p: { xs: 3, md: 5 },
        maxWidth: 1000,
        mx: "auto",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          mb: 4,
        }}
      >
        הצהרת נגישות
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        הצהרת נגישות – אתר שיינסטוק
      </Typography>

      <Typography sx={{ fontSize: 18, mb: 2, lineHeight: 2 }}>
       אנו בשיינסטוק מחויבים להעניק חוויית גלישה נוחה,
        מכבדת ונגישה לכלל המשתמשים,
         ופועלים באופן שוטף לשיפור נגישות האתר עבור אנשים עם מוגבלויות ועבור כלל לקוחותינו.
      </Typography>

      <Typography sx={{ fontSize: 18, mb: 4, lineHeight: 2 }}>
    במסגרת תהליך ההנגשה בוצעו באתר התאמות רבות בהתאם לעקרונות הנגישות המקובלים,
     במטרה לאפשר שימוש נוח, פשוט ונגיש בכל חלקי האתר.
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
       באתר בוצעו בין היתר ההתאמות הבאות:
      </Typography>

      <Box
        sx={{
          border: "1px solid #D81B60",
          borderRadius: 2,
          p: 3,
          mb: 4,
          backgroundColor: "#fff8fb",
        }}
      >
        {[
          "ניווט מלא באתר באמצעות המקלדת בלבד.",
          "מעבר בין כל רכיבי האתר באמצעות מקש Tab.",
          "הפעלת כפתורים, קישורים ושדות באמצעות המקלדת.",
          "סימון ברור של מוקד הפוקוס (Focus).",
          "שימוש בכותרות היררכיות המסייעות לקוראי מסך.",
          "התאמת שדות טפסים, תוויות והודעות שגיאה לטכנולוגיות מסייעות.",
          "הוספת תיאורי תמונה (Alt) לתמונות רלוונטיות.",
          "שמירה על ניגודיות צבעים תקינה.",
          "מבנה תוכן ברור ועקבי.",
          "שימוש ברכיבי HTML תקניים ובמאפייני ARIA.",
          "אפשרות לבצע את כל תהליך הרכישה באמצעות המקלדת בלבד.",
        ].map((item, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 18,
              mb: 1,
              lineHeight: 2,
            }}
          >
            • {item}
          </Typography>
        ))}
      </Box>

      {/* <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        תאימות דפדפנים
      </Typography> */}

      {/* <Typography sx={{ fontSize: 18, mb: 1 }}>
        האתר נבדק ופועל בדפדפנים הבאים:
      </Typography> */}

      {/* <Box sx={{ mb: 4 }}>
        {[
          "Google Chrome",
          "Microsoft Edge",
          "Mozilla Firefox",
          "Safari",
        ].map((browser, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 18,
              mb: 1,
            }}
          >
            • {browser}
          </Typography>
        ))}
      </Box> */}

      {/* <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        שימוש בטכנולוגיות מסייעות
      </Typography> */}

      {/* <Typography
        sx={{
          fontSize: 18,
          mb: 4,
          lineHeight: 2,
        }}
      >
        האתר תוכנן כך שיוכל לעבוד עם תוכנות קוראות מסך וטכנולוגיות מסייעות
        נוספות, בהתאם ליכולות הדפדפנים הנתמכים.
      </Typography> */}

      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        מגבלות נגישות
      </Typography>

      <Typography
        sx={{
          fontSize: 18,
          mb: 4,
          lineHeight: 2,
        }}
      >
        למרות המאמצים הרבים להנגיש את כלל חלקי האתר, ייתכן שחלקים מסוימים עדיין
        אינם נגישים באופן מלא או שטרם נמצא עבורם פתרון מיטבי. אנו ממשיכים לפעול
        באופן שוטף לשיפור הנגישות באתר.
      </Typography>

      <Typography
        variant="h5"
        sx={{
          fontWeight: "bold",
          mb: 2,
        }}
      >
        יצירת קשר בנושא נגישות
      </Typography>

      <Typography
        sx={{
          fontSize: 18,
          mb: 2,
          lineHeight: 2,
        }}
      >
        אם נתקלתם בקושי בגלישה באתר או שיש לכם הערה, שאלה או הצעה בנושא
        נגישות, נשמח לקבל את פנייתכם ולטפל בה בהקדם האפשרי.
      </Typography>

      <Typography
        sx={{
          fontSize: 18,
          mb: 2,
          lineHeight: 2,
        }}
      >
        ניתן ליצור קשר באמצעות עמוד "צור קשר" באתר או באמצעות פרטי ההתקשרות
        המופיעים באתר.
      </Typography>

      <Box
        sx={{
          border: "1px solid #D81B60",
          borderRadius: 2,
          p: 3,
          mb: 4,
          backgroundColor: "#fff8fb",
        }}
      >
        <Typography sx={{ fontSize: 18, mb: 1 }}>
          מומלץ לציין בפנייה:
        </Typography>

        {[
          "תיאור הבעיה.",
          "כתובת הדף שבו התרחשה הבעיה.",
          "סוג הדפדפן שבו השתמשתם.",
          "סוג המכשיר שממנו גלשתם.",
          "צילום מסך של התקלה (במידת האפשר).",
        ].map((item, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 18,
              mb: 1,
            }}
          >
            • {item}
          </Typography>
        ))}
      </Box>

      {/* <Typography
        sx={{
          textAlign: "center",
          fontSize: 18,
          fontWeight: "bold",
          mt: 4,
        }}
      >
        תאריך עדכון אחרון של הצהרת הנגישות: יולי 2026
      </Typography> */}
    </Box>
  );
}

